import React from 'react';
import { Button, Modal, ModalContent, ModalCloseButton } from '../common';

const CancelDeleteModal = ({ 
  isOpen, 
  onClose, 
  onCancel, 
  onDelete, 
  sessionName 
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent size="small">
        <ModalCloseButton onClose={onClose} />
        {/* Header */}
        <div className="flex items-center mb-6">
          <div className="flex-shrink-0 mr-3">
            <div className="w-10 h-10 bg-warning-light rounded-full flex items-center justify-center">
              <svg className="w-6 h-6 text-warning" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
          </div>
          <div>
            <h3 className="text-lg font-medium text-text-primary">
              Session Action Required
            </h3>
            <p className="text-sm text-text-secondary mt-1">
              What would you like to do with "{sessionName}"?
            </p>
          </div>
        </div>

        {/* Options */}
        <div className="space-y-4 mb-6">
          {/* Cancel Option */}
          <div className="border border-border-medium rounded-lg p-4 hover:bg-surface-subtle transition-colors">
            <div className="flex items-start">
              <div className="flex-shrink-0 mr-3 mt-1">
                <div className="w-5 h-5 bg-yellow-100 rounded-full flex items-center justify-center">
                  <svg className="w-3 h-3 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
              <div className="flex-1">
                <h4 className="font-medium text-text-primary mb-1">Cancel Session</h4>
                <p className="text-sm text-text-secondary mb-3">
                  Mark the session as cancelled but keep it in the system for records. 
                  Players will be notified of the cancellation.
                </p>
                <Button
                  onClick={onCancel}
                  variant="warning"
                  size="small"
                >
                  Cancel Session
                </Button>
              </div>
            </div>
          </div>

          {/* Delete Option */}
          <div className="border border-danger/30 rounded-lg p-4 hover:bg-danger-light transition-colors">
            <div className="flex items-start">
              <div className="flex-shrink-0 mr-3 mt-1">
                <div className="w-5 h-5 bg-danger-light rounded-full flex items-center justify-center">
                  <svg className="w-3 h-3 text-danger" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" clipRule="evenodd" />
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 012 0v4a1 1 0 11-2 0V7zM12 7a1 1 0 012 0v4a1 1 0 11-2 0V7z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
              <div className="flex-1">
                <h4 className="font-medium text-text-primary mb-1">Delete Session</h4>
                <p className="text-sm text-text-secondary mb-3">
                  Permanently remove the session and all player signups from the system. 
                  This action cannot be undone.
                </p>
                <Button
                  onClick={onDelete}
                  variant="danger"
                  size="small"
                >
                  Delete Permanently
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Close Button */}
        <div className="flex justify-end">
          <Button
            onClick={onClose}
            variant="secondary"
            size="small"
          >
            Cancel
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default CancelDeleteModal;
